'use client';
import PaginatorItemDots from './Paginator.ItemDots';
import { usePaginator } from './PaginatorContext';
import { ChevronLeft } from '@icons';

export default function PaginatorItemBack({ children = null, className = '' }) {
  const { setIndex, index, setScrollDirection } = usePaginator();

  const handleClick = () => {
    setScrollDirection('backward');
    if (index === 0) return;
    setIndex(index - 1);
  };
  return (
    <PaginatorItemDots
      handleClick={handleClick}
      excludeFromIndexes={true}
      className={`Paginator__item__back ${index === 0 ? 'Paginator__item__back-inactive' : ''} ${className}`}
    >
      {children ? children : <ChevronLeft />}
    </PaginatorItemDots>
  );
}
